// export const ApiUrl =
// 	"https://franchise-velocity.developer-ourbase-camp.com/api/v1" ||
// 	"http://localhost:4000";

export const ApiUrl =
	"https://admin.kickstartmyfranchise.com/api/v1" || "http://localhost:4000";

